import { $ as $$, add as $add, multiply as $multiply } from 'moneysafe';

const add = (...args) =>
    args
        .map(x => $$(x))
        .reduce((a, c) => $add(a, c), $$(0))
        .toNumber();

const subtract = (a, b) => $add($$(a), $$(b * -1)).toNumber();

const multiply = (...args) =>
    args
        .map(x => $$(x))
        .reduce((a, c) => $multiply(a, c), $$(1))
        .toNumber();

export default {
    add,
    subtract,
    multiply,
};
